<script>
  import { onMount } from "svelte";

  let container;
  export let noBold = false;
  export let noMaxWidth = false;

  onMount(() => {
    container.childNodes.forEach(element => {
      if (element.tagName == "H1") {
        element.className = `text-2xl leading-7 text-main sm:text-4xl sm:leading-9 mb-4 ${
          noBold ? "" : "font-bold"
        }`;
      } else if (element.tagName == "P") {
        element.className = "text-m leading-5 text-gray-900";

        element.childNodes.forEach(childElem => {
          if (childElem.tagName == "BR")
            childElem.className = "hidden sm:inline-block";
        });
      }
    });
  });
</script>

<div class="text-center mx-auto" class:max-w-xl={!noMaxWidth} bind:this={container}>
  <slot />
</div>
<!-- <style>
/* https://stackoverflow.com/questions/56619666/style-slot-elements-from-parent-component */
div :global(h1){
    @apply text-2xl; 
    @apply font-bold;
    @apply leading-7; 
    @apply text-gray-900; 
}

div :global(p){
    @apply text-sm;
    @apply leading-5;
    @apply text-gray-500;

}
   /* text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate */
/* text-sm leading-5 text-gray-500 */
</style> -->
